import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'ui/atoms';
import ContextButton from 'ui/molecules/ContextButton';

import { ReactComponent as IconCaretDown } from './caret-down.svg';

import './gpt-model-selection.css';

export type LLModel = {
  id: string;
  name: string;
  description: string;
  maxTokenCount?: number;
  modelType: string;
  disabled: boolean;
};

const GptModelSelection = ({ setGptModel, gptModel, gptModels }) => {
  const [showModal, setShowModal] = useState(false);
  const [gptModelName, setGptModelName] = useState('');

  useEffect(() => {
    if (!gptModels || gptModels.length === 0) return;
    const currentModel = gptModels.find((item) => item.id === gptModel);
    const name = currentModel?.name;
    if (!name) {
      setGptModel(gptModels[0]?.id);
      return;
    }

    setGptModelName(name);
  }, [gptModel, gptModels, setGptModel]);

  return (
    <div className="model-selection">
      <Button
        onClick={() => {
          setShowModal(true);
        }}
        type={'default'}
      >
        {gptModelName} <IconCaretDown />
      </Button>
      <Modal
        title="Select AI Model"
        open={showModal}
        onOk={() => {
          setShowModal(false);
        }}
        onCancel={() => {
          setShowModal(false);
        }}
        footer={[]}
      >
        <div className="gpt-model-selection">
          <div className="gpt-model-list">
            {gptModels &&
              gptModels.length > 0 &&
              gptModels.map((item) => {
                return (
                  <div
                    className="gpt-model-item"
                    key={`gpt-selection-${item.id}`}
                  >
                    {item.modelType}
                    <ContextButton
                      isSelected={item.id === gptModel}
                      title={item.name.toUpperCase()}
                      text={item.description}
                      value={item.id}
                      disabled={item.disabled}
                      setSelected={(value) => {
                        setGptModel(value);
                        setShowModal(false);
                      }}
                    ></ContextButton>
                  </div>
                );
              })}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GptModelSelection;
